import type { RegionParameters } from '@innovamat/glow-api-client';

import { getRegionalNumber } from '../../utils/regional-number';

const ANSWER_DECIMALS_PLACES = 2;

const containsOperations = (value: string): boolean => {
  return /[/\-+*]/.test(value);
};

const extractNumbers = (text: string): string[] => {
  return text.match(/\d+\.?\d*/g) || [];
};

const formatAnswer = (
  answer: string,
  regionParameters: RegionParameters
): string => {
  if (!answer) {
    return answer;
  }

  if (answer.match(/[a-zA-Z]/)) {
    return answer.toLowerCase();
  }

  if (!containsOperations(answer) || !answer) {
    return (
      getRegionalNumber({
        number: parseFloat(answer),
        fixedTo: ANSWER_DECIMALS_PLACES,
        parameters: regionParameters,
      }) || ''
    );
  }

  const numbers = extractNumbers(answer);
  let formattedOperation = answer;

  numbers.forEach((numberStr) => {
    const number = parseFloat(numberStr);

    if (!isNaN(number)) {
      const formattedNumber =
        getRegionalNumber({
          number,
          fixedTo: ANSWER_DECIMALS_PLACES,
          parameters: regionParameters,
        }) || '';

      formattedOperation = formattedOperation.replace(
        numberStr,
        formattedNumber || ''
      );
    }
  });

  return formattedOperation;
};

export { ANSWER_DECIMALS_PLACES, containsOperations, formatAnswer };
